module.exports = __webpack_public_path__ + "static/img/Basics.995aa73a.png";